import { offset } from "highcharts";
import React, { useEffect, useRef, useState } from "react";
import ReactApexChart from '../../../../components/ReusableComponents/ApexChartLazy';
import useCustomLogic from "../../../../Hooks/UseCustomLogic";
import { Typography } from "@mui/material";

const series = [91, 93, 98, 35, 99, 50, 92, 97, 91, 96, 99];

const PieChart = ({ seriesData = series }) => {
  const { isSm } = useCustomLogic();

  let data = seriesData.slice(0, 11);

  const options = {
    colors: [
      "rgb(141, 57, 155)",
      "rgb(225, 81, 75)",
      "rgb(158, 1, 65)",
      "rgb(78, 175, 180)",
      "rgb(78, 146, 180)",
      "rgb(96, 79, 161)",
      "rgb(251, 159, 89)",
      "rgb(71, 106, 180)",
      "rgb(234, 241, 149)",
      "rgb(78, 180, 107)",
      "rgb(174, 214, 156)",
    ],
    legend: {
      position: "left",
      show: "true",
      itemMargin: {
        horizontal: 20,
        vertical: 0,
      },
    },

    tooltip: {
      enabled: false,
      fillSeriesColor: false,
    },
    chart: {
      width: "480",
      type: "polarArea",
    },

    labels: [
      "PHOTOCOPIER",
      "TYPISTS",
      "STAMP VENDORS",
      "CANTEEN",
      "PUBLIC NOTARIES",
      "ATM",
      "BANK BRANCH",
      "OATH COMMISSIONERS",
      "POST OFFICE",
      "POLICE BOOTH",
      "FIRST-AID CARE",
    ],
    fill: {
      opacity: 1,
    },
    responsive: [
      {
        breakpoint: 320,
        options: {
          chart: {
            width: 240,
          },
        },
      },
      {
        breakpoint: 400,
        options: {
          chart: {
            width: 370,
          },
        },
      },
      {
        breakpoint: 1080,
        options: {
          chart: {
            width: 420,
          },
        },
      },
    ],
    dataLabels: {
      enabled: true,
      enabledOnSeries: false,
      // textAnchor: "start",
      formatter: function (val, opts) {
        // console.log(opts, "..............value");
        return opts?.w?.config?.series?.[opts?.seriesIndex] + "%";
        // return series[opts.seriesIndex] + "%";
      },
      style: {
        fontSize: "12px",
        fontFamily: "Helvetica, Arial, sans-serif",
      },
      offsetY: 0,
      offsetX: 0,

      position: "on",
    },
    plotOptions: {
      polarArea: {
        rings: {
          strokeWidth: 0,
        },
        spokes: {
          strokeWidth: 1,
        },
      },
    },
    yaxis: {
      show: false, // This hides the numbers on the polar chart
    },
  };

  // console.log(options, "...............options ");

  return (
    <div id="chart" style={{ position: "relative" }}>
      <ReactApexChart
        options={options}
        series={data}
        type="polarArea"
        width={"650px"}
      />
      <div
        style={{
          backgroundColor: "white",
          width: isSm ? "40px" : "70px",
          height: isSm ? "40px" : "70px",
          borderRadius: "100%",
          position: "absolute",
          left: isSm ? "310px" : "410px",
          bottom: isSm ? "68px" : "170px",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            fontSize: isSm ? "12px" : "16px",
            fontFamily: "sans-serif",
            fill: "rgb(26, 26, 26)",
          }}
        >
          {seriesData[11]}%
        </Typography>
        <Typography sx={{ fontSize: isSm ? "5px" : "9px" }}>
          FULL SERVICE COURTS
        </Typography>
      </div>
    </div>
  );
};

export default PieChart;
